import { Link } from "react-router-dom";
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const Header = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <nav
      style={{
        display: "flex",
        backgroundColor: "lightgrey",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
        borderBottom: "1px solid grey",
      }}
    >
      <img
        style={{ width: "75px", height: "75px" }}
        src="https://www.makerstations.io/content/images/2022/03/olja-lobkis-studygram-04.jpeg"
        alt="Welcome"
      />

      <h1>StudyApp</h1>

      <Link to="/home">
        <p>Home</p>
      </Link>

      {/* SHOW DASHBOARD ONLY FOR ADMIN OR INSTRUCTOR */}
      {user && (user.role === "admin" || user.role === "instructor") && (
        <Link to="/dashboard">
          <p>Dashboard</p>
        </Link>
      )}

      <Link to="/contact">
        <p>Contact</p>
      </Link>

      {/* SHOW USER NAME */}
      {user && (user.role === "admin" || user.role === "instructor") ? <Link to="/usersinfo">
          <p>usersinfo</p>
        </Link> : <p>Welcome, {user.name}</p>}

      <button
        style={{ backgroundColor: "lightcoral" }}
        onClick={logout}
      >
        Logout
      </button>
    </nav>
  );
};

export default Header;
